<template>
  <Base
    :go-to-new-template-page="goToNewTemplatePage"
    :go-to-edit-template="goToEditTemplate"
    :go-to-copy-item="goToCopyItem"
    :on-delete="params => reportsService.deleteTemplates(params)"
    :on-get="params => reportsService.getTemplates(params)"
    :on-export="params => reportsService.exportFormTemplate(params)"
    :on-import="params => reportsService.importFormTemplate(params)"
    new-template-text="New Case Template"
    remove-template-text="Remove Case Template"
    :json-export-field-list="jsonExportFieldList"
  />
</template>

<script>
import Base from './base';

import { ReportsMixin } from '../../../../mixins';

export default {
  title: 'Project-Templates',
  components: { Base },
  mixins: [ReportsMixin],
  data() {
    return {
      jsonExportFieldList: ['description', 'fields', 'groups', 'name', 'teams', 'checklistNo', 'email', 'emailCC', 'translation'],
    };
  },
  methods: {
    goToNewTemplatePage() {
      this.$router.push({ name: 'new-template', params: { id: Math.round(Math.random() * 10000) } });
    },
    goToEditTemplate(id) {
      this.$router.push({ name: 'edit-template', params: { id } });
    },
    goToCopyItem(id) {
      this.$router.push({ name: 'copy-template', params: { id } });
    }
  }
};
</script>
